import React from 'react';
import Modal from '../Common/Modal';
import { useWeb3 } from '../../context/Web3Context';
import { detectedWallets, isMobile, openTrustWalletDeepLink, openMetaMaskDeepLink } from '../../utils/wallet';

const WALLETS = [
  { key: 'metamask', name: 'MetaMask', icon: 'MM', color: '#f6851b' },
  { key: 'trust', name: 'Trust Wallet', icon: 'TW', color: '#3375bb' },
  { key: 'binance', name: 'Binance Wallet', icon: 'BW', color: '#f0b90b' },
  { key: 'injected', name: 'Browser Wallet', icon: 'BR', color: '#00d4ff' }
];

const WalletModal = ({ open, onClose }) => {
  const { connect, connecting } = useWeb3();
  const detected = detectedWallets();

  const onPick = async (key) => {
    const found = detected.find((d) => d.key === key);
    if (!found && isMobile()) {
      if (key === 'trust') {
        openTrustWalletDeepLink();
        return;
      }
      if (key === 'metamask') {
        openMetaMaskDeepLink();
        return;
      }
    }
    await connect(key);
    onClose && onClose();
  };

  return (
    <Modal open={open} onClose={onClose} title="Connect Wallet">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {WALLETS.map((w) => {
          const isDetected = detected.find((d) => d.key === w.key);
          return (
            <button
              key={w.key}
              onClick={() => onPick(w.key)}
              disabled={connecting}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
                padding: '14px 16px',
                background: 'var(--bg-input)',
                border: '1px solid var(--border-secondary)',
                borderRadius: 'var(--radius-md)',
                cursor: connecting ? 'not-allowed' : 'pointer',
                opacity: connecting ? 0.6 : 1,
                transition: 'all 0.25s ease',
                width: '100%',
                color: 'var(--text-primary)',
                textAlign: 'left'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = 'var(--accent-cyan)';
                e.currentTarget.style.boxShadow = 'var(--glow-cyan)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'var(--border-secondary)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div style={{
                width: 40,
                height: 40,
                borderRadius: 'var(--radius-md)',
                background: w.color,
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: 'Orbitron, sans-serif',
                fontWeight: 800,
                fontSize: 13
              }}>{w.icon}</div>
              <div style={{ flex: 1 }}>
                <div style={{
                  fontFamily: 'Orbitron, sans-serif',
                  fontSize: 14,
                  fontWeight: 600,
                  letterSpacing: '0.05em'
                }}>{w.name}</div>
                <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>
                  {isDetected ? 'Detected' : (isMobile() ? 'Open in app' : 'Not detected')}
                </div>
              </div>
              {isDetected && <span className="badge badge-green"><span className="badge-dot" />Ready</span>}
            </button>
          );
        })}
      </div>
      <div style={{
        marginTop: 20,
        padding: '12px 14px',
        background: 'rgba(0, 212, 255, 0.05)',
        border: '1px solid rgba(0, 212, 255, 0.2)',
        borderRadius: 'var(--radius-md)',
        fontSize: 12,
        color: 'var(--text-secondary)',
        lineHeight: 1.5
      }}>
        By connecting your wallet, you agree to interact with the staking smart contract on BNB Chain.
      </div>
    </Modal>
  );
};

export default WalletModal;
